import React, { useContext } from "react";
import Select from "react-select";
import { WindmillContext } from "@windmill/react-ui";
import { reactSelectCommonProps } from "utils/reactSelectTheme";
import { filterVisiblePrevileges } from "utils/privileges";

const SelectPrevilege = ({
  id,
  setSelecttedPrevilege,
  oldprevileges,
  label,
  data,
  previleges,
  selecttedPrevilege,
}) => {
  const { mode } = useContext(WindmillContext);
  const options =
    filterVisiblePrevileges(previleges)?.map((previlege) => ({
      value: previlege.id,
      label: previlege?.name,
    })) ?? [];

  options.unshift({ value: "FULL_ACCESS", label: "FULL ACCESS" });

  const handleChange = (selectedOption) => {
    setSelecttedPrevilege(selectedOption || []);
  };

  return (
    <>
      {options?.length > 0 && selecttedPrevilege && (
        <Select
          key={selecttedPrevilege.length}
          options={options}
          onChange={handleChange}
          defaultValue={selecttedPrevilege}
          isMulti
          name="previlege"
          className="react-select-container text-sm"
          classNamePrefix="react-select"
          {...reactSelectCommonProps(mode === "dark")}
        />
      )}
    </>
  );
};

export default SelectPrevilege;
